export const COD_TYPES = {
  FLAT: 'FLAT',
  PERCENTAGE: 'PERCENTAGE',
};

export const PRICING_SCHEME_UNIT = {
  PER_CBM: 'PER_CBM',
  PER_DROP_POINT: 'PER_DROP_POINT',
  PER_KM: 'PER_KM',
  PER_LOAD: 'PER_LOAD',
  PER_ORDER: 'PER_ORDER',
  PER_ROUTE: 'PER_ROUTE',
  RENTAL: 'RENTAL',
};

export const SCHEME_UNIT = {
  DAILY: 'DAILY',
  KG: 'KG',
  MONTHLY: 'MONTHLY',
  PER_ROUTE: 'PER_ROUTE',
  WEEKDAY: 'WEEKDAY',
  WEEKEND: 'WEEKEND',
};

export default {};
